import PublicPageWrapper from "./public-page-wrapper";

export default PublicPageWrapper;
